import { render, staticRenderFns } from "./chat_gpt_inp.vue?vue&type=template&id=cad283e6&scoped=true&"
import script from "./chat_gpt_inp.vue?vue&type=script&lang=ts&"
export * from "./chat_gpt_inp.vue?vue&type=script&lang=ts&"
import style0 from "./chat_gpt_inp.vue?vue&type=style&index=0&id=cad283e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad283e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VContent,VMain})
